import PersonAccess from "../services/database/personAccess";
import AbsenceAccess from "../services/database/absenceAccess";
import ProjectAccess from "../services/database/projectAccess";
import OrderAccess from "../services/database/orderAccess";
import OrderItemAccess from "../services/database/orderItemAccess";
import CostUnitAccess from "../services/database/costUnitAccess";
import MachineAccess from "../services/database/machineAccess";
import WorkplaceAccess from "../services/database/workplaceAccess";
import WorkprocessAccess from "../services/database/workprocessAccess";
import WorkCombinationAccess from "../services/database/workCombinationAccess";
import {
    absenceTable,
    costUnitTable,
    machineTable,
    orderItemTable,
    orderTable,
    personTable,
    projectTable,
    workCombinationTable,
    workplaceTable,
    workprocessTable
} from "../config.json";

export const getCurrentFlowChart = (flowChart, level) => {
    const currentFlowChart = {...flowChart};

    if (level.length === 0) {
        return currentFlowChart;
    }

    const firstLevel = level[0];
    let restOfLevel = [...level];
    restOfLevel.shift();

    const foundFlowChartItem = flowChart.menus.find(item => {
        return item.id === firstLevel;
    });

    if (foundFlowChartItem === null || foundFlowChartItem === undefined) {
        return currentFlowChart;
    } else {
        return getCurrentFlowChart(foundFlowChartItem, restOfLevel);
    }
};

export const getTable = (flowChart, currentFlowChart) => {
    if (flowChart === null || flowChart === undefined) return null;
    if (currentFlowChart === null || currentFlowChart === undefined) return null;
    const foundTable = flowChart.tables.find(table => {
        return table.name === currentFlowChart.table;
    });
    return foundTable;
};

export const getDataFromList = (flowChart, currentRecordingFlowChart) => {
    if (flowChart === null || flowChart === undefined) return null;
    if (
        currentRecordingFlowChart === null ||
        currentRecordingFlowChart === undefined
    )
        return null;
    const foundList = flowChart.lists.find(list => {
        const result = list.name === currentRecordingFlowChart.list;
        return result;
    });
    return foundList;
};

export const getDataFromPersonTable = async database => {
    const list = await PersonAccess.getAll(database, personTable);
    return {
        name: "persons",
        fields: [
            {
                name: "number"
            },
            {
                name: "firstname"
            },
            {
                name: "surnamename"
            }
        ],
        entries: list
    };
};

export const getDataFromAbsenceTable = async database => {
    const list = await AbsenceAccess.getAll(database, absenceTable);
    return {
        name: "absences",
        fields: [
            {
                name: "number"
            },
            {
                name: "description"
            }
        ],
        entries: list
    };
};

export const getDataFromProjectTable = async database => {
    const list = await ProjectAccess.getAll(database, projectTable);
    return {
        name: "projects",
        fields: [
            {
                name: "number"
            },
            {
                name: "description"
            }
        ],
        entries: list
    };
};

export const getDataFromOrderTable = async database => {
    const list = await OrderAccess.getAll(database, orderTable);
    return {
        name: "orders",
        fields: [
            {
                name: "number"
            },
            {
                name: "description"
            }
        ],
        entries: list
    };
};

export const getDataFromOrderItemTable = async (database, orderDbId) => {
    const list = (await OrderItemAccess.getAll(database, orderItemTable)).filter(
        orderItem => orderItem.orderDbId === orderDbId
    );

    return {
        name: "orderItems",
        fields: [
            {
                name: "number"
            },
            {
                name: "description"
            }
        ],
        entries: list
    };
};

export const getDataFromCostUnitTable = async database => {
    const list = await CostUnitAccess.getAll(database, costUnitTable);
    return {
        name: "costUnits",
        fields: [
            {
                name: "number"
            },
            {
                name: "description"
            }
        ],
        entries: list
    };
};

export const getDataFromMachineTable = async database => {
    const list = await MachineAccess.getAll(database, machineTable);
    return {
        name: "machines",
        fields: [
            {
                name: "number"
            },
            {
                name: "description"
            }
        ],
        entries: list
    };
};

export const getDataFromWorkplaceTable = async database => {
    const list = await WorkplaceAccess.getAll(database, workplaceTable);
    return {
        name: "workplaces",
        fields: [
            {
                name: "number"
            },
            {
                name: "description"
            }
        ],
        entries: list
    };
};

export const getDataFromWorkprocessTable = async database => {
    const list = await WorkprocessAccess.getAll(database, workprocessTable);
    return {
        name: "workprocesss",
        fields: [
            {
                name: "number"
            },
            {
                name: "description"
            }
        ],
        entries: list
    };
};

export const getDataFromWorkCombinationTable = async (database, table, number) => {
    let list = []
    switch (table) {
        case "order":
            list = await WorkCombinationAccess.getAllByOrderNumber(
                database,
                workCombinationTable,
                number
            );
            break;
        default:
            list = await WorkCombinationAccess.getAll(database, workCombinationTable);
    }
    return {
        name: "workCombination",
        fields: [
            {
                name: "number"
            },
            {
                name: "description"
            }
        ],
        entries: list
    };
};

export const injectRemoveTableHeader = (state, rowInfo, column) => {
    if (column.Header === "remove") {
        return {
            style: {display: "none"} // override style for 'myHeaderTitle'.
        };
    }
    // However you should return an object, if there is no styles you want to override do
    return {}; // no styles.
};

export const getAlphaNumberStandardArray = number => {
    switch (number) {
        case "1":
            return [
                {
                    title: {
                        text: "1",
                        style: {}
                    }
                }
            ];
        case "2":
            return [
                {
                    title: {
                        text: "2",
                        style: {}
                    }
                },
                {
                    title: {
                        text: "A",
                        style: {}
                    }
                },
                {
                    title: {
                        text: "B",
                        style: {}
                    }
                },
                {
                    title: {
                        text: "C",
                        style: {}
                    }
                }
            ];
        case "3":
            return [
                {
                    title: {
                        text: "3",
                        style: {}
                    }
                },
                {
                    title: {
                        text: "D",
                        style: {}
                    }
                },
                {
                    title: {
                        text: "E",
                        style: {}
                    }
                },
                {
                    title: {
                        text: "F",
                        style: {}
                    }
                }
            ];
        case "4":
            return [
                {
                    title: {
                        text: "4",
                        style: {}
                    }
                },
                {
                    title: {
                        text: "G",
                        style: {}
                    }
                },
                {
                    title: {
                        text: "H",
                        style: {}
                    }
                },
                {
                    title: {
                        text: "I",
                        style: {}
                    }
                }
            ];
        case "5":
            return [
                {
                    title: {
                        text: "5",
                        style: {}
                    }
                },
                {
                    title: {
                        text: "J",
                        style: {}
                    }
                },
                {
                    title: {
                        text: "K",
                        style: {}
                    }
                },
                {
                    title: {
                        text: "L",
                        style: {}
                    }
                }
            ];
        case "6":
            return [
                {
                    title: {
                        text: "6",
                        style: {}
                    }
                },
                {
                    title: {
                        text: "M",
                        style: {}
                    }
                },
                {
                    title: {
                        text: "N",
                        style: {}
                    }
                },
                {
                    title: {
                        text: "O",
                        style: {}
                    }
                }
            ];
        case "7":
            return [
                {
                    title: {
                        text: "7",
                        style: {}
                    }
                },
                {
                    title: {
                        text: "P",
                        style: {}
                    }
                },
                {
                    title: {
                        text: "Q",
                        style: {}
                    }
                },
                {
                    title: {
                        text: "R",
                        style: {}
                    }
                },
                {
                    title: {
                        text: "S",
                        style: {}
                    }
                }
            ];
        case "8":
            return [
                {
                    title: {
                        text: "8",
                        style: {}
                    }
                },
                {
                    title: {
                        text: "T",
                        style: {}
                    }
                },
                {
                    title: {
                        text: "U",
                        style: {}
                    }
                },
                {
                    title: {
                        text: "V",
                        style: {}
                    }
                }
            ];
        case "9":
            return [
                {
                    title: {
                        text: "9",
                        style: {}
                    }
                },
                {
                    title: {
                        text: "W",
                        style: {}
                    }
                },
                {
                    title: {
                        text: "X",
                        style: {}
                    }
                },
                {
                    title: {
                        text: "Y",
                        style: {}
                    }
                },
                {
                    title: {
                        text: "Z",
                        style: {}
                    }
                }
            ];
        case "0":
            return [
                {
                    title: {
                        text: "0",
                        style: {}
                    }
                }
            ];
        default:
            return [];
    }
};
